import { render, staticRenderFns } from "./DictionaryGroupEditPage.vue?vue&type=template&id=3391de11&scoped=true&"
import script from "./DictionaryGroupEditPage.vue?vue&type=script&lang=js&"
export * from "./DictionaryGroupEditPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3391de11",
  null
  
)

export default component.exports